import React from 'react'
import PropTypes from 'prop-types'
import FlatButton from 'material-ui/FlatButton'

// TODO: replace material-ui FlatButton
const GroupControls = ({ isCustomGroup, onClickEdit }) => (
  <div>
    {isCustomGroup && <FlatButton label="Edit Group" onClick={onClickEdit} />}
  </div>
)

GroupControls.propTypes = {
  isCustomGroup: PropTypes.bool.isRequired,
  onClickEdit: PropTypes.func.isRequired,
}

export default GroupControls



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/GroupControls.js